import { useTranslation } from 'react-i18next';

export const EmptyState = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center h-full py-20 gap-2 text-center">
      <p className="text-ui-text3 text-sm font-medium">{t('chat.emptyState.title')}</p>
      <p className="text-ui-text2 text-xs">{t('chat.emptyState.examples')}</p>
    </div>
  );
};
